import Model from 'src/models/model'

/**
 * @typedef {import('vue-router').NavigationGuard} NavigationGuard
 */

/**
 * Immediately clear any prior previewed permissions when loading the app for
 * a user who should not be allowed to preview permissions. This is to prevent
 * accidental user access to non-permitted UI elements.
 * @type {NavigationGuard}
 */
export async function checkPreviewPermissionsAccess (_to, _from, next) {
  await Model.ensureBooted()
  if (Model.context && !Model.context.isPreviewPermissionsPermitted) {
    Model.context.stopPreviewingPermissions()
  }

  next()
}

/**
 * This guard is intended to be used as a global beforeEach guard set in consumer mode
 * for SEO purposes, though it can also be added as a beforeEnter guard to individual routes.
 *
 * This guard adds, updates, or removes the `<link rel="canonical" href="${currentUrl}">` tag
 * based on whether the destination route has a `meta: { canonical: true }` field. When the
 * user navigates to another route without the meta field, the canonical link tag is removed.
 * @type {NavigationGuard}
 */
export async function addOrRemoveCanonicalLinkTag (to, _from, next) {
  await Model.ensureBooted()

  const isCanonicalRoute = to.meta.canonical
  if (isCanonicalRoute) {
    Model.app.config.globalProperties.$addCanonicalLinkTag(to.path)
  } else {
    Model.app.config.globalProperties.$removeCanonicalLinkTag()
  }

  next()
}
